export default {
  title: {
    csvDataExport: "CSV出力",
  },
  range: "期間",
  format: "フォーマット",
  completedReception: "受付完了",
  messages: {
    acceptedDownload: "ダウンロードを受け付けました。",
    outputCompletedAfterEmailNotification: "出力完了後メールでお知らせします。",
    operationOfficeRequired: "運営会社を選択してください。",
    dateRangeRequired: "期間を選択してください。",
  },
}
